export default {
  address: ['user-input', 'map', 'informer'],
  'about-object': [
    'common/cadastral-number',
    'settlement-name',
    'common/build-year',
    'common/material-type-house',
    'common/suburban-total-area',
    'share-amount-rent',
    'common/floors-count-house',
    'common/bedrooms-count',
    'visual-divider',
    'common/wc-location-type',
    'common/heating-type-house',
    'visual-divider',
    'repair-type',
    'in-house-rent',
    'common/area-land',
  ],
  'price-and-deal-terms': [
    'price-rent',
    'utilities-terms',
    'visual-divider',
    'bargain',
    'prepay-type',
    'self-employed',
    'deposit',
    'fee',
  ],
};
